import { JobName, PaymentComponent, PaymentJobDto } from "dtos/payment.job.dto";

export const getSlotTiming = (slot: number) => {
  if (slot === 1) return "4am ET";
  if (slot === 2) return "8am ET";
  if (slot === 3) return "12pm ET";

  return "";
};

export const getJobTitleLabel = (job: JobName) => {
  if (job === JobName.PAYMENT_SLOT) return "Paynote Attempt";
  if (job === JobName.WATERFALL) return "Payment Waterfall Scheduler";
  if (job === JobName.WATERFALL_STEP) return "Payment Attempt";
  if (job === JobName.D_ONLY) return "Creditor Full Payment Attempt";
  if (job === JobName.PARTIAL_CREDITOR) return "Per Creditor Payment Attempt";
  if (job === JobName.CREDITOR_OUTGOING) return "Creditor Outgoing Scheduler";
  if (job === JobName.DISTRIBUTION) return "Wallet Funds Distribution";
  if (job === JobName.NEXT_LEDGER) return "Schedule Next Week Ledger";
};

export function readLs<T>(key: string, fallback: T): T {
  try {
    const v = localStorage.getItem(key);
    return v !== null ? (JSON.parse(v) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeLs(key: string, value: unknown) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    console.log("Unable to save refresh state");
  }
}

export function formatDate(iso?: string) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function formatAmount(v?: number) {
  if (v == null) return "—";
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
}

// ─── job_data field accessors ─────────────────────────────────────────────

export function getJobAmount(job: PaymentJobDto): number | undefined {
  return (job.job_data as any)?.amount;
}
export function getJobComponent(job: PaymentJobDto): PaymentComponent | undefined {
  return (job.job_data as any)?.component;
}
export function getJobSlot(job: PaymentJobDto): number | undefined {
  return (job.job_data as any)?.slot;
}
export function getJobPmIndex(job: PaymentJobDto): number | undefined {
  const v = (job.job_data as any)?.pmIndex;
  return typeof v === "number" ? v : undefined;
}
export function getCreditorName(job: PaymentJobDto): string | undefined {
  return (job.job_data as any)?.creditorName;
}
export function getCreditorWalletCount(job: PaymentJobDto): number | undefined {
  const cw = (job.job_data as any)?.creditorWallets;
  return Array.isArray(cw) ? cw.length : undefined;
}
export function getAttemptCount(job: PaymentJobDto): number | undefined {
  const v = (job.job_data as any)?.attemptCount;
  return typeof v === "number" ? v : undefined;
}
export function getIsPartialCreditor(job: PaymentJobDto): boolean | undefined {
  const v = (job.job_data as any)?.isPartialCreditor;
  return typeof v === "boolean" ? v : undefined;
}
